import { TNotificationsResponse, TSelectedNotification } from '../types'
import { useLoading } from 'shared/hooks'
import { useDeleteNotificationMutation } from '../graphql/deleteNotifications.types'
import { GetNotificationsDocument } from '../graphql/getNotifications.types'

import { NotificationsDelete } from 'shared/__gql-types'

export const useDeleteNotification = () => {
  const [deleteNotifications, { loading }] = useDeleteNotificationMutation()

  const onDeleteNotifications = (notificationIds: TSelectedNotification[]) => {
    deleteNotifications({
      variables: { notifications: notificationIds },
      update(cache, { data }, { variables }) {
        if (typeof data?.deleteNotification !== 'undefined' && data?.deleteNotification?.result === 'success') {
          const res = cache.readQuery<{ getNotifications: TNotificationsResponse[] }>({
            query: GetNotificationsDocument
          })

          cache.writeQuery({
            query: GetNotificationsDocument,
            data: {
              getNotifications: res?.getNotifications.filter((item) =>
                variables?.notifications && Array.isArray(variables.notifications) &&
                !variables.notifications.find((el: NotificationsDelete) => el.id === item.id && el.notification_type === item.notification_type)
              )
            }
          })
        }
      }
    })
  }

  useLoading({ isLoading: loading })

  return {
    onDeleteNotifications
  }
}
